module.exports = __webpack_public_path__ + "img/样例2.cb325f20.png";